
export function setNettoPrices(netto, newMennyiseg, decDigit, decMult, cikk) {
  let nettoBesz =  (Math.round((Number(netto) * newMennyiseg) * Math.pow(10, decMult)) / Math.pow(10, decMult)).toFixed(decDigit);
  let bruttoEgyseg = (Math.round(Number(netto * (1 + (cikk.aktualisAfaErtek / 100))) * Math.pow(10, 6)) / Math.pow(10, 6)).toFixed(6);
  let bruttoBesz =  (Math.round(Number(netto * (1 + (cikk.aktualisAfaErtek / 100))) * newMennyiseg * Math.pow(10, decMult)) / Math.pow(10, decMult)).toFixed(decDigit);
  return [nettoBesz, bruttoEgyseg, bruttoBesz];
};
